import React, { FC } from 'react';
import { TLinksSectionProps } from './types/linksSection.types';
import { TFooterLink } from '../../../../types/footerLink.types';
import LinksAccordion from '../linksAccordion';

const LinksSection: FC<TLinksSectionProps> = ({ fields }) => {
  const accordions = fields?.map((item: TFooterLink) => {
    return <LinksAccordion fields={item} key={item?.id} />;
  });

  return <>{accordions}</>;
};

export default LinksSection;
